module.exports = __webpack_public_path__ + "static/img/floatLeftImg2.855802b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floatLeftImg2.png
// module id = w4M/
// module chunks = 2